/**
 * Build stamp frontendu - z jakého kódu vznikl tenhle bundle.
 *
 * Hodnoty zapisuje při buildu scripts/zapis-build-info.js do .env.production.local
 * a react-scripts je zapečou jako REACT_APP_* proměnné. Při `npm start` (vývojový
 * server) tam nejsou - proto výchozí hodnoty.
 *
 * Číslo verze (APP_VERSION) je „naposledy oznámené vydání" a neříká nic
 * o nasazeném kódu; na to je tenhle otisk.
 */
export interface BuildInfo {
  hash: string;
  vetev: string;
  necommitnuteZmeny: boolean | null;
  sestaveno: string;
}

export const FRONTEND_BUILD: BuildInfo | null = process.env.REACT_APP_BUILD_HASH
  ? {
      hash: process.env.REACT_APP_BUILD_HASH,
      vetev: process.env.REACT_APP_BUILD_VETEV || 'neznámá',
      necommitnuteZmeny: process.env.REACT_APP_BUILD_ZMENY === '1',
      sestaveno: process.env.REACT_APP_BUILD_SESTAVENO || '',
    }
  : null;

/** „b44f7b8 (develop, necommitnuté změny) · 17. 9. 2026 15:44" */
export const popisBuildu = (b: BuildInfo | null): string => {
  if (!b) return 'bez otisku';

  const priznaky = [b.vetev, b.necommitnuteZmeny ? 'necommitnuté změny' : null].filter(Boolean);
  const cas = b.sestaveno
    ? new Date(b.sestaveno).toLocaleString('cs-CZ', {
        day: 'numeric',
        month: 'numeric',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      })
    : '';

  return [`${b.hash} (${priznaky.join(', ')})`, cas].filter(Boolean).join(' · ');
};
